import { render, staticRenderFns } from "./DxPopupTable.vue?vue&type=template&id=4d321da5&"
import script from "./DxPopupTable.vue?vue&type=script&lang=js&"
export * from "./DxPopupTable.vue?vue&type=script&lang=js&"
import style0 from "./DxPopupTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports